/* eslint-disable no-console */

import { getLoggerConfig, LoggerConfig, setLoggerConfig } from './logger.conf';

export const DupontLoggerConfig = (config: LoggerConfig) => setLoggerConfig(config);

const formatLog = (argument: any) => {
  try {
    return typeof argument === 'string' ? argument : JSON.stringify(argument);
  } catch {
    return `${argument}`;
  }
};

const logToServer = (message: string, level = 'info') => {
  const { isLogToServer, logToServerURL } = getLoggerConfig();
  if (!isLogToServer || !logToServerURL) return;

  fetch(logToServerURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message, level }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to send log to server');
      }
    })
    .catch(error => {
      console.error('Error sending log to server:', error);
    });
};

const DupontLogger = (caller = '') => {
  const { isLogToConsole, isLogToServer } = getLoggerConfig();

  const logToServerIfNeeded = (level: string, ...args: any) => {
    if (isLogToServer) {
      const logMessage = `[${caller}] ${args.map(formatLog).join(' ')}`;
      logToServer(logMessage, level);
    }
  };

  const log = (...args: any) => {
    if (isLogToConsole) console.log(`[${caller}]`, ...args);
    logToServerIfNeeded('log', ...args);
  };

  const error = (...args: any) => {
    if (isLogToConsole) console.error(`[${caller}]`, ...args);
    logToServerIfNeeded('error', ...args);
  };

  const info = (...args: any) => {
    if (isLogToConsole) console.info(`[${caller}]`, ...args);
    logToServerIfNeeded('info', ...args);
  };

  const warn = (...args: any) => {
    if (isLogToConsole) console.warn(`[${caller}]`, ...args);
    logToServerIfNeeded('warn', ...args);
  };

  return { log, error, info, warn };
};

export default DupontLogger;
